export const AT_LEAST_ONE_NUMBER_REGEX = /\d+/;
export const AT_LEAST_ONE_SPECIAL_CHARACTER = /[!@#$%^&*()_+\-=\[\]{}|\\":;'\/.,<>~`£§]/;
export const AT_LEAST_ONE_UPPERCASE_LETTER = /[A-Z]/;
